<p-dialog header="Header" [(visible)]="visible" [modal]="true" [style]="{ width: '450px' }" [draggable]="false" [resizable]="false" (onHide)="cancelar()">
    <ng-template pTemplate="header">
      <span class="text-xl  font-bold">¿Estás seguro(a) que deseas realizar el pedido?</span>
    </ng-template>
    <hr />
    <p>Tienes {{numItem}} producto(s) en el Carrito y el valor del pedido es {{totPriceWishList | currency}}</p>

    <hr />
    <ng-template pTemplate="footer">
      <p-button label="Si estoy seguro." ></p-button>
      <p-button label="Cancelar" (click)="cancelar()"></p-button>
    </ng-template>
</p-dialog>
  